import { SITE_URL } from './blogSeoMetadata';

export const HOME_TITLE = 'CalorieScience | Nutrition Platform for Professionals';
export const HOME_DESCRIPTION =
  'AI meal planning, patient tracking and smart recommendations for nutrition professionals—in one platform.';
export const HOME_STRUCTURED_DATA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'SoftwareApplication',
      name: 'CalorieScience',
      url: `${SITE_URL}/`,
      applicationCategory: 'HealthApplication',
      operatingSystem: 'Web',
      description: HOME_DESCRIPTION,
      publisher: { '@id': `${SITE_URL}/#organization` },
    },
    {
      '@type': 'Organization',
      '@id': `${SITE_URL}/#organization`,
      name: 'CalorieScience',
      url: `${SITE_URL}/`,
      logo: `${SITE_URL}/logo.png`,
    },
    {
      '@type': 'WebSite',
      name: 'CalorieScience',
      url: `${SITE_URL}/`,
      publisher: { '@id': `${SITE_URL}/#organization` },
    },
  ],
};
